import React, { Fragment, useState } from "react";
import { Badge, Tooltip }  from "reactstrap";
import moment from 'moment'

import DefaultOfferImg from "~/assets/images/default-offer.png";
import Survey from "~/services/surveys";

const Networks = {
  1: "Cpx Research",
  2: "TheoreReach" ,
  3: "BitLabs"     ,
  4: "inBrainAi"   ,
  5: "Offer Daddy" ,

  6: "Revenue Wall",
  7: "Pollfish"    ,
  8: "Yuno"        ,
  9: "Wannads"     ,
};

const SurveyCard = ({item})=> {

  const formatDate = (date)=> moment(date).format("YYYY-MM-DD");
  const [toggle, setToggle] = useState(false);

  return (
    <Fragment>
      <img src={DefaultOfferImg} />

      <div className="item-details">
        <div>
          <h6> {Networks[item.networkId]} </h6>
          <div className="d-flex" style={{flexDirection: "row"}}>
            <Badge style={{marginRight: 5}} color="points"> POINTS: {item.points} </Badge>
            {item.bonusPoints && (
              <div>
                <div id='bonus' style={{color: "green", fontWeight: 700, fontSize: 13}}> +{item.bonusPoints}</div>
                <Tooltip
                  placement="top"
                  isOpen={toggle}
                  toggle={()=> setToggle(!toggle)}
                  target='bonus'
                >
                  Bonus from Points Booster
                </Tooltip>
              </div>
            )}
          </div>
        </div>
        <div className="text-right">
          <h6> {formatDate(item.createdAt)} </h6>
          {
            item.postbackType === Survey.postbackType.CLAIM
              ? <Badge color="custom-completed"> COMPLETED</Badge>
              : <Badge color="custom-reversal"> REVERSAL  </Badge>
          }
        </div>
      </div>
    </Fragment>
  );
};

export default SurveyCard;
